import React from 'react';
import './LoaderBeer.css';

const LoaderBeer = ({ size = 'medium', message = 'Loading...' }) => {
  return (
    <div className={`loader-beer ${size}`}>
      <div className="loader-beer__container">
        {/* Beer Pint Glass */}
        <div className="beer-pint">
          {/* Glass outline */}
          <div className="pint-glass">
            {/* Beer liquid */}
            <div className="beer-liquid">
              <div className="beer-fill"></div>
            </div>
            {/* Foam head */}
            <div className="beer-foam">
              <div className="foam-bubble foam-bubble--1"></div>
              <div className="foam-bubble foam-bubble--2"></div>
              <div className="foam-bubble foam-bubble--3"></div>
            </div>
          </div>
        </div>
        
        {/* Loading message */}
        {message && (
          <div className="loader-beer__message">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoaderBeer;